import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { dateArrayToString } from '../shared/date-utils';

@Pipe({
  name: 'dateArrayToString',
})
export class DateArrayToStringPipe implements PipeTransform {
  transform(value: number[], format: string): string {
    return dateArrayToString(value, format);
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [DateArrayToStringPipe],
  exports: [DateArrayToStringPipe],
})
export class DateArrayToStringPipeModule {}



// WEBPACK FOOTER //
// ./ts/app/pipes/date-array-to-string.pipe.ts